import i18n from "./i18n";
import {isValidLocationString, validURL} from "./helper";

export const nameRules = function () {
    i18n.locale = localStorage.getItem("locale")
    return [
        (v) => !!v || i18n.t("__RulesName1")
    ]
}
export const emailRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ]};

export const alarmTypeRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "Alarmtype is required"]};

export const titleRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "Title is required"];
}
export const usernameRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "Username is required"];
}
export const passwordRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "Password is required"];
}
export const clientSecretRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [
        (v) => !!v || "Client Secret is required",
        (v) => !/\//.test(v) || "No '/' allowed",
    ];
}
export const descriptionRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "Description is required"];
}
export const vendorRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "Vendor is required"];
}
export const deviceTypeRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "DeviceType is required"];
}
export const firmwareRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "Firmware is required"];
}
export const functionRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "Function is required"];
}
export const urlRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [
        (v) => !!v || "URL is required",
        (v) => validURL(v) || "URL not valid",
    ];
}
export const applicationIdRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "Application-Id is required"];
}
export const integrationTypeRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [
        (v) => !!v || "Integration-Type is required",
    ];
}
export const integrationRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "Integration is required"];
}
export const apiKeyRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "API-Key is required"];
}
export const organizationIdRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "Organization-Id is required"];
}
export const asIdRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "AS-Id is required"];}
export const asKeyRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "AS-Key is required"];}
export const csvFileRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "CSV-File is required"];}
export const yamlFileRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "YAML-File is required"];
}
export const mcDevEUIRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [
        (v) => !!v || "Multicast Device EUI is required",
        (v) => v.length === 16 || "16 Hexadecimal chars are required",
    ];}
export const nwAdrRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [
        (v) => !!v || "Network address is required",
        (v) => v.length === 8 || "8 Hexadecimal chars are required",
    ];}
export const nwSKeyRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [
        (v) => !!v || "Network Session Key is required",
        (v) => v.length === 32 || "32 Hexadecimal chars are required",
    ];}
export const appSKeyRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [
        (v) => !!v || "Application Session Key is required",
        (v) => v.length === 32 || "32 Hexadecimal chars are required",
    ];}
export const groupIdRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [(v) => !!v || "Group ID is required"];}

export const tableRules = function(){[
    (v) => (!!v && true) || i18n.t("__RulesValue1")
]};

export const locationRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [
        (v) =>
            /^[0-9,. ]*$/.test(v) ||
            "Input must not contain letters and special characters",
        (v) =>
            isValidLocationString(v) || "Location must be in the format '<lat>, <lng>'",
    ];}
export const latitudeRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [
        (v) => !!v || ( () => this.$t("__RulesValue1")),
        (v) => (!isNaN(v) && v >= -90 && v <= 90) || "Value must between -90 and 90",
    ];}
export const longitudeRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [
        (v) => !!v || ( () => this.$t("__RulesValue1"),
            (v) =>
                (!isNaN(v) && v >= -180 && v <= 180) || "Value must between -180 and 180"),
    ];}

export const updateIntervalRules =  function () {
    i18n.locale = localStorage.getItem("locale")
    return [
        (v) => /^[0-9]*$/.test(v) || "Only numbers are allowed as input",
        (v) => (v >= 60 && v !== 0) || "Minimum 60 seconds",
    ];}